import React from 'react';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import InputLabel from '@mui/material/InputLabel';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker, DatePicker } from '@mui/x-date-pickers';
import * as ETVConstants from '../ETVConstants';
import dayjs from 'dayjs';
import MessageDialog from '../tools/MessageDialog';
import {
  Box,
  Chip,
  Container,
  Divider,
  Paper,
  Stack
} from '@mui/material';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

class Countdown extends React.Component {
  constructor(props) {
    super(props);
    this.selectedScreens = this.selectedScreens.bind(this);
    this.closeScreenSelection = this.closeScreenSelection.bind(this);
    this.closeInfoMessage = this.closeInfoMessage.bind(this);
  }

  state = {
    ticker_text: '',
    channel: '0',
    window: '',
    info_type: '',
    info_message: '',
    info_title: '',
    selected_screens: [],
    validating: false,
    selected_date: ETVConstants.createDateNow(),
    selected_time: ETVConstants.createDateNow(),
  };

  // ---------- helpers ----------
  combineDateTime() {
    const d = dayjs(this.state.selected_date);
    const t = dayjs(this.state.selected_time);
    return d.hour(t.hour()).minute(t.minute()).second(0).millisecond(0);
  }

  selectedScreens(screenIDs) {
    this.showWindow('select_screens_div', false);
    this.setState({ selected_screens: screenIDs });
  }

  closeScreenSelection() {
    this.showWindow('select_screens_div', false);
  }

  showWindow(divID, show) {
    show ? this.setState({ window: divID }) : this.setState({ window: '' });
  }

  showInfoMessage(title, msg) {
    this.setState({ window: 'message_div', info_title: title, info_message: msg, info_type: 'info' });
  }
  showSuccessMessage(title, msg) {
    this.setState({ window: 'message_div', info_title: title, info_message: msg, info_type: 'success' });
  }
  showErrorMessage(title, msg) {
    this.setState({ window: 'message_div', info_title: title, info_message: msg, info_type: 'error' });
  }
  closeInfoMessage() {
    this.setState({ window: '', info_message: '', info_title: '', info_type: '' });
  }

  getFilename() {
    const m = new Date();
    const dateString = '' + m.getUTCFullYear() + (m.getUTCMonth() + 1) + m.getUTCDate() + m.getUTCHours() + m.getUTCMinutes() + m.getUTCSeconds();
    return dateString + '_countdown.html';
  }

  saveCountdown() {
    this.setState({ validating: true });
    const updatedDateTime = this.combineDateTime();

    this.showInfoMessage('', 'Uploading... ');

    let url = ETVConstants.getServerBase() + '/template_servlet?action=create_and_save_template&user_id=' + this.props.user_id;
    url += '&template_path=templates/countdown/countdown_template.html';
    url += '&filename=' + this.getFilename();
    url += '&showing_time=20';
    url += '&param_0.name=@@title@@&param_0.value=' + ETVConstants.encodeURIComponentSafe(this.state.ticker_text);
    url += '&param_1.name=@@date@@&param_1.value=' + encodeURIComponent(updatedDateTime.format());
    url += '&desc=' + ETVConstants.encodeURIComponentSafe(this.state.ticker_text);
    url += '&thumbnail=' + encodeURIComponent(ETVConstants.getServerBase() + '/image_assets/thumbnails/countdown_thumbnail.jpg');

    if (this.state.selected_screens && this.state.selected_screens.length > 0) {
      url += '&channel=' + this.state.channel;
      this.state.selected_screens.forEach((screen) => {
        url += '&device_id=' + screen;
      });
    }

    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        () => {
          this.setState({
            ticker_text: '',
            channel: '0',
            selected_screens: [],
            validating: false,
            selected_date: dayjs(),
            selected_time: dayjs(),
          });
          this.showSuccessMessage('', ETVConstants.trans('the_countdown_ticker_was_stored_in_your_content_library'));
        },
        (error) => {
          this.showErrorMessage('', 'error happened: ' + error);
          this.setState({
            ticker_text: '',
            channel: '0',
            selected_screens: [],
            validating: false,
            selected_date: dayjs(),
            selected_time: dayjs(),
          });
        }
      );
  }

  buttonIsDisabled() {
    if (!this.state.ticker_text) return true;
    if (this.state.ticker_text.trim().length === 0) return true;
    if (this.state.ticker_text.length > 100) return true;
    return false;
  }

  // ---------- render ----------
  render() {
    const selectedCount = this.state.selected_screens?.length || 0;
    const deadline = this.combineDateTime();

    const textTooLong = this.state.ticker_text.length > 100;

    return (
      <Box maxWidth="md" sx={{ py: 3 }}>
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <HourglassBottomIcon />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {ETVConstants.trans('countdown_ticker')}
            </Typography>
          </Stack>
        </Stack>

        <Card sx={{ borderRadius: 3 }}>
          <CardContent>
            <Typography variant="body1" color="text.secondary">
              {ETVConstants.trans('countdown_clock_until_given_date')}
            </Typography>

            <Stack spacing={2.5} sx={{ mt: 2 }}>
              <TextField
                required
                label={ETVConstants.trans('countdown_text_max_100_chars')}
                fullWidth
                value={this.state.ticker_text}
                onChange={(e) => this.setState({ ticker_text: e.target.value })}
                inputProps={{ maxLength: 100 }}
                error={textTooLong || (this.state.validating && this.state.ticker_text.trim().length === 0)}
                helperText={
                  textTooLong
                    ? `${this.state.ticker_text.length}/100`
                    : this.state.validating && this.state.ticker_text.trim().length === 0
                    ? ETVConstants.trans('required_field')
                    : `${this.state.ticker_text.length}/100`
                }
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2} alignItems="center">
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <DatePicker
                      label={ETVConstants.trans('countdown_date')}
                      format="YYYY-MM-DD"
                      value={dayjs(this.state.selected_date)}
                      onChange={(date) => this.setState({ selected_date: dayjs(date) })}
                      slotProps={{ textField: { fullWidth: true } }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TimePicker
                      label={ETVConstants.trans('countdown_time')}
                      value={dayjs(this.state.selected_time)}
                      onChange={(time) => this.setState({ selected_time: dayjs(time) })}
                      slotProps={{ textField: { fullWidth: true } }}
                    />
                  </Grid>
                </Grid>
              </LocalizationProvider>

              <Stack direction="row" spacing={1} alignItems="center">
                <Button variant="contained" onClick={() => this.showWindow('select_screens_div', true)}>
                  {ETVConstants.trans('select_screens')}&nbsp;({this.state.selected_screens?this.state.selected_screens.length:0})
                </Button>
              </Stack>

              <FormControl sx={{ maxWidth: 320 }}>
                <InputLabel>{ETVConstants.trans('channel')}</InputLabel>
                <Select
                  label={ETVConstants.trans('channel')}
                  id="channel_id"
                  value={this.state.channel}
                  onChange={(e) => this.setState({ channel: e.target.value })}
                >
                  <MenuItem value={'0'}>Channel 0</MenuItem>
                  <MenuItem value={'1'}>Channel 1</MenuItem>
                  <MenuItem value={'2'}>Channel 2</MenuItem>
                  <MenuItem value={'3'}>Channel 3</MenuItem>
                  <MenuItem value={'4'}>Channel 4</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </CardContent>

          <CardActions sx={{ px: 3, pb: 3, justifyContent: 'flex-end' }}>
            <Button
              disabled={this.buttonIsDisabled()}
              color="primary"
              startIcon={<UploadFileIcon />}
              variant="contained"
              onClick={() => this.saveCountdown()}
            >
              {ETVConstants.trans('upload')}
            </Button>
          </CardActions>
        </Card>

        {/* Screen selector overlay */}
        <div id="select_screens_div" style={{ display: this.state.window === 'select_screens_div' ? 'block' : 'none' }}>
          <SelectAvailableScreensNew
            isOpen={this.state.window === 'select_screens_div'}
            user_id={this.props.user_id}
            closeHook={this.closeScreenSelection}
            selectedScreens={this.selectedScreens}
            selected={this.state.selected_screens ? this.state.selected_screens : []}
          />
        </div>

        <MessageDialog
          type={this.state.info_type}
          open={this.state.window === 'message_div'}
          onClose={this.closeInfoMessage}
          title={this.state.info_title}
          message={this.state.info_message}
        />
      </Box>
    );
  }
}

export default Countdown;
